
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor"}},[_c('g',{attrs:{"stroke-linecap":"round","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M12 9v6","fill":"none"}}),_c('path',{attrs:{"d":"M14 12h-4"}})]),_c('path',{attrs:{"d":"M12 10a3 3 0 013-3M12 10a3 3 0 00-3-3","stroke-linecap":"round","stroke-miterlimit":"10"}}),_c('g',[_c('path',{attrs:{"d":"M12 14a3 3 0 003 3M12 14a3 3 0 01-3 3","stroke-linecap":"round","stroke-miterlimit":"10"}})])])])
          )
        }
      }
    